import { AnimatePresence, motion } from "framer-motion";
import { X, Plus, Minus, Trash2 } from "lucide-react";
import { useCart } from "../context/CartContext";
import { toast } from "sonner";

export const CartDrawer = () => {
  const { items, open, setOpen, remove, setQty, total, count, clear } = useCart();

  const checkout = () => {
    toast.success("Order reserved! Pick up in-store within 24h.");
    clear();
    setOpen(false);
  };

  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            onClick={() => setOpen(false)}
            className="fixed inset-0 bg-ink/70 backdrop-blur-sm z-[70]"
          />
          <motion.aside
            data-testid="cart-drawer"
            initial={{ x: "100%" }} animate={{ x: 0 }} exit={{ x: "100%" }}
            transition={{ ease: [0.76, 0, 0.24, 1], duration: 0.5 }}
            className="fixed top-0 right-0 bottom-0 w-full sm:w-[440px] bg-ink2 z-[80] flex flex-col border-l border-bone/10"
          >
            <div className="flex items-center justify-between px-8 py-6 border-b border-bone/10">
              <h3 className="font-display text-2xl font-bold uppercase tracking-tight">Your Bag ({count})</h3>
              <button data-testid="cart-close" onClick={() => setOpen(false)} className="text-bone hover:text-honey">
                <X size={24} />
              </button>
            </div>

            <div className="flex-1 overflow-y-auto px-8 py-6 space-y-6">
              {items.length === 0 && <p className="text-stone">Your bag is empty. Explore the menu.</p>}
              {items.map((i) => (
                <div key={i.slug} data-testid={`cart-item-${i.slug}`} className="flex gap-4">
                  <img src={i.image} alt={i.name} className="w-20 h-24 object-cover" />
                  <div className="flex-1">
                    <div className="font-medium text-bone">{i.name}</div>
                    <div className="text-xs text-stone uppercase tracking-wider">{i.brand}</div>
                    <div className="text-honey font-bold mt-1">${i.price.toFixed(2)}</div>
                    <div className="flex items-center gap-3 mt-2">
                      <button onClick={() => setQty(i.slug, i.qty - 1)} className="border border-bone/20 p-1 hover:border-honey"><Minus size={14} /></button>
                      <span className="text-sm w-5 text-center">{i.qty}</span>
                      <button onClick={() => setQty(i.slug, i.qty + 1)} className="border border-bone/20 p-1 hover:border-honey"><Plus size={14} /></button>
                      <button onClick={() => remove(i.slug)} className="ml-auto text-stone hover:text-terracotta"><Trash2 size={16} /></button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {items.length > 0 && (
              <div className="border-t border-bone/10 px-8 py-6 space-y-4">
                <div className="flex justify-between text-lg">
                  <span className="text-stone">Subtotal</span>
                  <span className="font-display font-bold">${total.toFixed(2)}</span>
                </div>
                <button
                  data-testid="checkout-button"
                  onClick={checkout}
                  className="w-full rounded-full bg-honey text-ink px-8 py-4 font-bold tracking-widest uppercase hover:bg-bone transition-colors"
                >
                  Reserve for Pickup
                </button>
                <p className="text-xs text-stone text-center">Reserve online, pay & verify ID in-store.</p>
              </div>
            )}
          </motion.aside>
        </>
      )}
    </AnimatePresence>
  );
};
